"use client";

import { useEffect } from "react";
import { Icon } from "@/components/atoms/Icon/Icon";
import { CircleAlertGlyph } from "@/components/atoms/Icon/drawnIcons";
import { Button } from "@/components/atoms/Button/Button";
import { Text } from "@/components/atoms/Text/Text";
import { reloadForChunkLoadError } from "@/lib/chunk-load-reload";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    reloadForChunkLoadError(error, "error_boundary");
  }, [error]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-canvas" data-sentry-component="Error" data-sentry-source-file="error.tsx">
      <div className="w-full max-w-md px-4 text-center sm:px-6">
        <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-surface-hover">
          <Icon icon={CircleAlertGlyph} aria-label="Icon" className="size-10" data-sentry-element="Icon" data-sentry-source-file="error.tsx" />
        </div>
        <Text variant="heading-md-bold-tracking-tight" as="h1" className="mt-8" data-sentry-element="Text" data-sentry-source-file="error.tsx">
          Oops, something went wrong!
        </Text>
        <p className="mt-4 text-foreground-tertiary">
          We&apos;re sorry, but an unexpected error has occurred. Please try
          again later or contact support if the issue persists.
        </p>
        <div className="mt-6 flex flex-row justify-center gap-4">
          <Button onClick={reset} variant="compact-outline" size="compact" data-sentry-element="Button" data-sentry-source-file="error.tsx">
            Retry
          </Button>
          <Button variant="compact-primary" size="compact" data-sentry-element="Button" data-sentry-source-file="error.tsx">
            <Link href="/" data-sentry-element="Link" data-sentry-source-file="error.tsx">Go to Homepage</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
